import { makeComponent } from '../core';
import React from 'react';


export const Sidebar = makeComponent( class extends React.Component<{$id:string,width?:any,overlayBody?:boolean,fixedOpen?:boolean}>{
    render(){
        return this.props.children || null;
    }
});